import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import Joyride from 'react-joyride';
import { FiSmartphone } from 'react-icons/fi';
import { LoginSignup } from './pages/LoginSignup';
import { CreateRide } from './pages/CreateRide.jsx';
import { Navbar } from './components/Navbar.jsx';
import { SearchRide } from './pages/SearchRide.jsx';
import { MyRides } from './pages/MyRides.jsx';
import MyRequests from './pages/MyRequests.jsx';
import { RideDetails } from './pages/RideDetails.jsx';
import { HostRide } from './pages/HostRide.jsx';
import { Error404 } from './pages/Error404.jsx';
import { ForgotPassword } from './pages/ForgotPassword/SendEmail.jsx';
import { UpdatePassword } from './pages/ForgotPassword/UpdatePassword.jsx';
import CloseOnLogout from './pages/CloseOnLogout.jsx';
import TermsAndConditions from './pages/TermsAndConditions.jsx';
import bg from './bg.jpg';
import Feedback from './pages/Feedback.jsx';
import { MobileNavGuide } from './components/MobileNavGuide.jsx';

function App() {
  const { pathname } = useLocation();
  const navigator = useNavigate();
  const authToken = localStorage.getItem("token");

  // Joyride setup
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [steps, setSteps] = useState([]);
  const steps_lg = [
    {
      target: "#search-ride_lg",
      content: "Search for rides here",
    },
    {
      target: "#create-ride_lg",
      content: "Offer your ride here",
    },
    {
      target: "#my-rides_lg",
      content: "See rides that you created here",
    },
    {
      target: "#my-requests_lg",
      content: "See rides that you requested to join here",
    },
  ];

  const steps_sm = [
    {
      target: "#hamburger-menu",
      content: "Click here to open the menu",
    },
  ]

  useEffect(() => {
    if (pathname != '/terms-and-conditions' && pathname !== '/forgot-password' && pathname !== '/update-password' && !(authToken?.length > 0)) {
      navigator('/login');
    }

    // if (authToken && !localStorage.getItem("hasSeenTour")) {
    //   setSteps(window.innerWidth < 640 ? steps_sm : steps_lg);
    //   setTimeout(() => { setRun(true); }, 500);

    //   localStorage.setItem("hasSeenTour", "true");
    // }
  }, [authToken, pathname]);

  // PWA install prompt state
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    // Only show if not seen before
    if (!localStorage.getItem("hasSeenInstallPrompt")) {
      const handler = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setShowInstallPrompt(true);

        // Auto-dismiss after 10 seconds
        const timer = setTimeout(() => setShowInstallPrompt(false), 5000);

        // Mark as seen
        localStorage.setItem("hasSeenInstallPrompt", "true");

        // Clear timer if prompt is dismissed manually
        return () => clearTimeout(timer);
      };
      window.addEventListener('beforeinstallprompt', handler);

      return () => window.removeEventListener('beforeinstallprompt', handler);
    }
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => {
        setShowInstallPrompt(false);
        setDeferredPrompt(null);
      });
    }
  };

  const showNavbar = pathname !== '/login' && pathname !== '/forgot-password' && pathname !== '/update-password' && pathname !== "/terms-and-conditions";

  return (
    <div
      className='min-h-screen w-screen flex flex-col overflow-x-hidden overflow-y-auto bg-zinc-100'
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* Install PWA Prompt */}
      {showInstallPrompt && (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 bg-amber-100 border border-amber-400 rounded-2xl px-4 py-5 shadow-lg z-50 flex flex-col items-center max-w-xs w-[90vw]">
          <button
            className="absolute top-2 right-2 text-lg text-zinc-700 hover:text-zinc-900"
            aria-label="Dismiss"
            onClick={() => setShowInstallPrompt(false)}
            style={{ background: "none", border: "none", cursor: "pointer" }}
          >
            &#10005;
          </button>
          <span className="text-center text-base text-zinc-800 mb-3 flex items-center justify-center gap-2">
            <FiSmartphone className="w-5 h-5 text-amber-600 flex-shrink-0" /> <span>Install <span className="font-bold text-amber-700">Travel Buddy</span> as an app for a better experience!</span>
          </span>
          <button
            className="bg-amber-500 text-white px-4 py-2 rounded-lg hover:bg-amber-600 w-full font-semibold transition"
            onClick={handleInstallClick}
          >
            Install
          </button>
        </div>
      )}


      {/* Mobile Onboarding Guide */}
      <MobileNavGuide />

      {/* Fixed Navbar */}
      {showNavbar && (
        <div className="fixed top-0 left-0 right-0 z-40">
          <Navbar />
        </div>
      )}

      {/* Spacer div - takes up space equal to navbar height */}
      {showNavbar && <div className="h-16" />} {/* Adjust h-16 to match your navbar height */}

      {/* Joyride Component */}
      {/* run && <Joyride
        steps={steps}
        run={run}
        stepIndex={stepIndex}
        continuous
        showSkipButton
        showProgress
        styles={{
          options: {
            zIndex: 10000,
            primaryColor: 'black',
            textColor: 'black',
            overlayColor: 'rgba(0, 0, 0, 0.5)',
          },
        }}
        callback={(data) => {
          const { action, index, status, type } = data;
          if (window.innerWidth < 640 && index == 0 && type === 'step:after' && action === 'next') document.getElementById("hamburger-menu").click();
          if (type === 'step:after' && action === 'next') {
            setStepIndex(index + 1);
          }

          if (type === 'step:after' && action === 'prev') {
            setStepIndex(index - 1);
          }

          if (status === 'finished' || status === 'skipped') {
            setRun(false);
            setStepIndex(0);
          }
        }}
      />
      */}
      {authToken && <CloseOnLogout />}
      <Routes>
        <Route index element={<SearchRide />} />
        <Route path="/login" element={<LoginSignup />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/update-password" element={<UpdatePassword />} />
        <Route path="/create" element={<CreateRide />} />
        <Route path="/search" element={<SearchRide />} />
        <Route path="/ride-details/search" element={<RideDetails />} />
        <Route path="/my-rides" element={<MyRides />} />
        <Route path="/my-rides/:id" element={<HostRide />} />
        <Route path="/my-requests" element={<MyRequests />} />
        <Route path="/feedback" element={<Feedback />} />
        <Route path="*" element={<Error404 />} />
      </Routes>

      {/* Footer */}
      {showNavbar && (
        <footer className="w-full border-t border-white/10 bg-black/30 backdrop-blur-md py-4 mt-auto">
          <p className="text-center text-xs text-white/60 tracking-wide">
            Developed by{' '}
            <span className="text-white/80 font-medium">Shashwat Shikhar Dwivedi</span>
            {' & '}
            <span className="text-white/80 font-medium">Shivansh Srivastava</span>
          </p>
        </footer>
      )}
    </div>
  );
}

export default App;